"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmulationOptions = void 0;

var _enum = _interopRequireDefault(require("enum"));

var EmulationOptions = new _enum.default({
  READER: "EMULATION_READER",
  ADMIN: "EMULATION_ADMIN",
  OWNER: "EMULATION_OWNER"
});
exports.EmulationOptions = EmulationOptions;